import { Component } from "react";
import ButtonComponent from "./cubeComponent/form/ButtonComponent";
import { BUTTON_TYPES } from "./cubeComponent/constants/globalVariable";
import * as Sentry from "@sentry/react";
import pageBreak from "../src/assets/icons/svg/pageBreak.svg";
import { withTranslation } from "react-i18next";
function ignoreErrors(err: any) {
  if(typeof err == "object" && err.message == "Cannot pick from outside the canvas area."){
    return true
  }
  else if (
    ((typeof err == "string" && err == "Uncaught ReferenceError: member called after shutdown") ||
      (typeof err == "object" && err.message == "member called after shutdown") ||
      (typeof err == "object" && err.message == "Incompatible load types."))
  ) {
    return true;
  } else if (
    typeof err == "object" &&
    Object.hasOwn(err, "scFunction") &&
    !globalThis.location.href.includes("designviewer")
  ) {
    return true;
  } else if (
    typeof err == "string" &&
    (err.includes("ResizeObserver loop") ||
      err.includes("ResizeObserver loop completed with undelivered notifications"))
  ) {
    return true;
  }
  return false;
}
class ErrorBoundary extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      hasError: null,
    };

    globalThis.addEventListener("unhandledrejection", (event) => {
      const error = event.reason;
      console.log(error);
      if (!ignoreErrors(error)) {
        //TODO: uncomment below line after october month
        // this.setState({ hasError: true });
        Sentry.captureException(error);
      }
    });

    globalThis.addEventListener("error", (err) => {
      console.log(err);
      if (!ignoreErrors(err.message)) {
        if (err.filename) {
          /*
            Assuming third party libraries like clarity and freshchat donot allow getting filename due to cors issue
          */
          this.setState({
            hasError: true,
          });
        }
        Sentry.captureException(err);
      }
    });
  }

  static getDerivedStateFromError(err: any) {
    console.log(err);
    if (!ignoreErrors(err.message)) {
      Sentry.captureException(err);
    }
    return {
      hasError: !ignoreErrors(err.message),
    };
  }

  handlePageRefresh() {
    globalThis.location.reload();
  }

  componentDidUpdate(prevProps: any) {
    if ((this.props as any).location !== prevProps.location) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if ((this.state as any).hasError) {
      return (
        <div className="h-full justify-center bg-white items-center flex gap-5 flex-col w-full">
          <div className="flex flex-col gap-2 items-center justify-center">
            <img src={pageBreak} alt="pageBreak" />

            <span className="font-semibol text-2xl">{(this.props as any).t("An unexpected error occurred")}</span>
            <span>{(this.props as any).t("Our team has been notified about this and is working on a resolution")}</span>
            <span>{(this.props as any).t("Meanwhile please refresh and try again")}</span>
            <span>
              {" "}
              <ButtonComponent onClick={this.handlePageRefresh} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
                {(this.props as any).t("Refresh")}
              </ButtonComponent>
            </span>
          </div>
        </div>
      );
    }
    return (this.props as any).children;
  }
}
const ErrorBoundaryWithTranslation: any = withTranslation()(ErrorBoundary);
export default ErrorBoundaryWithTranslation;
